import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import { observer } from "mobx-react";
import React from "react";
import { DataTableProps, styles } from "./commons";
import { DataTableBody } from "./DataTableBody";
import { DataTableFooter } from "./DataTableFooter";
import { DataTableHeader } from "./DataTableHeader";

class DataTableComponent extends React.Component<DataTableProps> {
  public render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Table className={classes.table}>
          <DataTableHeader {...this.props} />
          <DataTableBody {...this.props} />
        </Table>
        <DataTableFooter {...this.props} />
      </div>
    );
  }
}

export const DataTable = withStyles(styles)(observer(DataTableComponent));
